import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import './SrLabel.less';

const fontSizeMapping = {
  small: '13px',
  normal: '14px',
  large: '18px',
};

const fontSizeToLineHeightMapping = {
  small: '15px',
  normal: '20px',
  large: '26px',
};

export const SR_LABEL_THEME_GREEN_CHECKMARK = 'SR_LABEL_THEME_GREEN_CHECKMARK';
export const SR_LABEL_THEME_GREEN_CHECKMARK_V2 = 'SR_LABEL_THEME_GREEN_CHECKMARK_V2';
export const SR_LABEL_THEME_ORANGE_X = 'SR_LABEL_THEME_ORANGE_X';
export const SR_LABEL_THEME_ORANGE_INFO_RECTANGLE = 'SR_LABEL_THEME_ORANGE_INFO_RECTANGLE';
const SR_LABEL_THEME_TO_CLASSNAME_MAPPING = {
  [SR_LABEL_THEME_GREEN_CHECKMARK]: 'green-checkmark',
  [SR_LABEL_THEME_GREEN_CHECKMARK_V2]: 'green-checkmark-v2',
  [SR_LABEL_THEME_ORANGE_X]: 'orange-x',
  [SR_LABEL_THEME_ORANGE_INFO_RECTANGLE]: 'orange-info',
};
const SR_LABEL_THEMES = Object.keys(SR_LABEL_THEME_TO_CLASSNAME_MAPPING);

const SrLabel = ({
  color,
  opacity,
  padding,
  borderColor,
  backgroundColor,
  label,
  fontSize,
  iconUrl,
  iconWidth,
  iconHeight,
  iconDropShadow,
  justifyCenter,
  alignCenter,
  theme,
  onClick,
}) => {

  return (
    <SrBox
      opacity={opacity}
      border={borderColor ? `2px solid ${borderColor}` : null}
      backgroundColor={backgroundColor}
      padding={padding || (theme
        ? null
        : borderColor
          ? '13px 15px'
          : '16px 17px')}
      cursor={onClick ? 'pointer' : null}
      onClick={onClick}
      styleName={classnames('SrLabel', SR_LABEL_THEME_TO_CLASSNAME_MAPPING[theme])}
      className='SrLabel'
    >
      <SrFlex
        align={alignCenter ? 'center' : null}
        justify={justifyCenter ? 'center' : null}
      >
        {(iconUrl || theme) &&
          <SrBox marginTop='3px' marginLeft='4px' marginRight='12px'>
            {theme ? (
              <SrBox styleName='icon' />
            ) : (
              <img
                alt='listing status icon'
                src={iconUrl}
                style={{
                  height: iconHeight,
                  width: iconWidth,
                  filter: iconDropShadow ? `drop-shadow(${iconDropShadow})` : null,
                }}
              />
            )}
          </SrBox>
        }
        <SrText
          color={color}
          font='greycliff'
          weight='800'
          fontSize={fontSizeMapping[fontSize]}
          lineHeight={fontSizeToLineHeightMapping[fontSize]}
          letterSpacing='0.5px'
          styleName='text'
        >
          {label}
        </SrText>
      </SrFlex>
    </SrBox>
  );
};

SrLabel.propTypes = {
  opacity: PropTypes.string,
  padding: PropTypes.string,
  color: PropTypes.string,
  borderColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  iconUrl: PropTypes.string,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  iconDropShadow: PropTypes.string,
  justifyCenter: PropTypes.bool,
  alignCenter: PropTypes.bool,
  onClick: PropTypes.func,
  fontSize: PropTypes.oneOf(Object.keys(fontSizeMapping)),
  theme: PropTypes.oneOf(SR_LABEL_THEMES),
};

SrLabel.defaultProps = {
  color: 'blueGreycliff',
  iconWidth: 'auto',
  iconHeight: '20px',
  fontSize: 'large',
};

SrLabel.displayName = 'SrLabel';

export default SrLabel;
